var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSunburst(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 924,
    height: 924,
    viewBox: "0 0 924 924",
    preserveAspectRatio: "false",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "sunburst",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.87549e-05 482.248L3.05176e-05 441.923L462.085 456.461L462.085 466.494L2.87549e-05 482.248Z",
    fill: "url(#paint0_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.923 2.69923e-05L482.248 3.05176e-05L467.71 462.085L457.677 462.085L441.923 2.69923e-05Z",
    fill: "url(#paint1_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.085 149.598L149.599 121.085L466.063 458.108L458.968 465.202L121.085 149.598Z",
    fill: "url(#paint2_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.572 121.085L803.086 149.599L466.063 466.063L458.968 458.968L774.572 121.085Z",
    fill: "url(#paint3_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.87549e-05 482.248L3.05176e-05 441.923L462.085 456.461L462.085 466.494L2.87549e-05 482.248Z",
    fill: "url(#paint4_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.923 2.69923e-05L482.248 3.05176e-05L467.71 462.085L457.677 462.085L441.923 2.69923e-05Z",
    fill: "url(#paint5_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.085 149.598L149.599 121.085L466.063 458.108L458.968 465.202L121.085 149.598Z",
    fill: "url(#paint6_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.572 121.085L803.086 149.599L466.063 466.063L458.968 458.968L774.572 121.085Z",
    fill: "url(#paint7_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9635 601.157L10.5268 562.207L460.63 456.652L463.226 466.344L20.9635 601.157Z",
    fill: "url(#paint8_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.014 20.9635L361.964 10.5267L467.519 460.63L457.827 463.226L323.014 20.9635Z",
    fill: "url(#paint9_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8265 248.504L71.9888 213.582L464.898 457.214L459.881 465.903L51.8265 248.504Z",
    fill: "url(#paint10_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.667 51.8265L710.589 71.9888L466.957 464.898L458.268 459.881L675.667 51.8265Z",
    fill: "url(#paint11_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5268 361.964L20.9636 323.014L463.541 456.652L460.944 466.344L10.5268 361.964Z",
    fill: "url(#paint12_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.207 10.5267L601.157 20.9635L467.518 463.541L457.827 460.944L562.207 10.5267Z",
    fill: "url(#paint13_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.582 71.9887L248.504 51.8264L466.956 459.273L458.268 464.289L213.582 71.9887Z",
    fill: "url(#paint14_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.182 213.582L872.344 248.504L464.898 466.956L459.881 458.268L852.182 213.582Z",
    fill: "url(#paint15_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.171 482.248L924.171 441.923L462.085 456.461L462.085 466.494L924.171 482.248Z",
    fill: "url(#paint16_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.923 924.171L482.248 924.171L467.71 462.085L457.677 462.085L441.923 924.171Z",
    fill: "url(#paint17_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.572 803.086L803.086 774.572L466.063 458.108L458.968 465.202L774.572 803.086Z",
    fill: "url(#paint18_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.085 774.572L149.599 803.086L466.063 466.063L458.968 458.968L121.085 774.572Z",
    fill: "url(#paint19_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.171 482.248L924.171 441.923L462.085 456.461L462.085 466.494L924.171 482.248Z",
    fill: "url(#paint20_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.923 924.171L482.248 924.171L467.71 462.085L457.677 462.085L441.923 924.171Z",
    fill: "url(#paint21_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.572 803.086L803.086 774.572L466.063 458.108L458.968 465.202L774.572 803.086Z",
    fill: "url(#paint22_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.085 774.572L149.599 803.086L466.063 466.063L458.968 458.968L121.085 774.572Z",
    fill: "url(#paint23_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.644 361.964L903.207 323.014L460.63 456.652L463.226 466.344L913.644 361.964Z",
    fill: "url(#paint24_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.207 913.644L601.157 903.207L467.519 460.63L457.827 463.226L562.207 913.644Z",
    fill: "url(#paint25_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.182 710.589L872.344 675.667L464.898 457.214L459.881 465.903L852.182 710.589Z",
    fill: "url(#paint26_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.582 852.182L248.504 872.344L466.957 464.898L458.268 459.881L213.582 852.182Z",
    fill: "url(#paint27_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.207 601.157L913.644 562.207L463.541 456.652L460.944 466.344L903.207 601.157Z",
    fill: "url(#paint28_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.014 903.207L361.964 913.644L467.518 463.541L457.827 460.944L323.014 903.207Z",
    fill: "url(#paint29_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.667 872.344L710.589 852.182L466.956 459.273L458.268 464.289L675.667 872.344Z",
    fill: "url(#paint30_linear_1030_217764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8265 675.667L71.9888 710.589L464.898 466.956L459.881 458.268L51.8265 675.667Z",
    fill: "url(#paint31_linear_1030_217764)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1030_217764",
    x1: 462.085,
    y1: 461.477,
    x2: 0.0000296628,
    y2: 461.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1030_217764",
    x1: 462.694,
    y1: 462.085,
    x2: 462.694,
    y2: 0.0000288081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1030_217764",
    x1: 462.515,
    y1: 461.655,
    x2: 135.772,
    y2: 134.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1030_217764",
    x1: 462.515,
    y1: 462.515,
    x2: 789.259,
    y2: 135.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1030_217764",
    x1: 462.085,
    y1: 461.477,
    x2: 0.0000296628,
    y2: 461.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1030_217764",
    x1: 462.694,
    y1: 462.085,
    x2: 462.694,
    y2: 0.0000288081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1030_217764",
    x1: 462.515,
    y1: 461.655,
    x2: 135.772,
    y2: 134.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1030_217764",
    x1: 462.515,
    y1: 462.515,
    x2: 789.259,
    y2: 135.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1030_217764",
    x1: 461.928,
    y1: 461.498,
    x2: 15.5878,
    y2: 581.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1030_217764",
    x1: 462.673,
    y1: 461.928,
    x2: 343.076,
    y2: 15.5877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1030_217764",
    x1: 462.389,
    y1: 461.559,
    x2: 62.2117,
    y2: 230.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1030_217764",
    x1: 462.612,
    y1: 462.389,
    x2: 693.655,
    y2: 62.2117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1030_217764",
    x1: 462.243,
    y1: 461.498,
    x2: 15.9026,
    y2: 341.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1030_217764",
    x1: 462.673,
    y1: 462.243,
    x2: 582.269,
    y2: 15.9025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1030_217764",
    x1: 462.612,
    y1: 461.781,
    x2: 231.569,
    y2: 61.6035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1030_217764",
    x1: 462.389,
    y1: 462.612,
    x2: 862.567,
    y2: 231.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1030_217764",
    x1: 462.085,
    y1: 461.477,
    x2: 924.171,
    y2: 461.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1030_217764",
    x1: 462.694,
    y1: 462.085,
    x2: 462.694,
    y2: 924.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1030_217764",
    x1: 462.515,
    y1: 461.655,
    x2: 789.259,
    y2: 788.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1030_217764",
    x1: 462.515,
    y1: 462.515,
    x2: 135.772,
    y2: 789.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1030_217764",
    x1: 462.085,
    y1: 461.477,
    x2: 924.171,
    y2: 461.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1030_217764",
    x1: 462.694,
    y1: 462.085,
    x2: 462.694,
    y2: 924.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1030_217764",
    x1: 462.515,
    y1: 461.655,
    x2: 789.259,
    y2: 788.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1030_217764",
    x1: 462.515,
    y1: 462.515,
    x2: 135.772,
    y2: 789.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1030_217764",
    x1: 461.928,
    y1: 461.498,
    x2: 908.268,
    y2: 341.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1030_217764",
    x1: 462.673,
    y1: 461.928,
    x2: 582.269,
    y2: 908.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1030_217764",
    x1: 462.389,
    y1: 461.559,
    x2: 862.567,
    y2: 692.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1030_217764",
    x1: 462.612,
    y1: 462.389,
    x2: 231.569,
    y2: 862.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1030_217764",
    x1: 462.243,
    y1: 461.498,
    x2: 908.583,
    y2: 581.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1030_217764",
    x1: 462.673,
    y1: 462.243,
    x2: 343.076,
    y2: 908.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1030_217764",
    x1: 462.612,
    y1: 461.781,
    x2: 693.655,
    y2: 861.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1030_217764",
    x1: 462.389,
    y1: 462.612,
    x2: 62.2117,
    y2: 693.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#FFC700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#FFC700"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunburst);
export default __webpack_public_path__ + "static/media/sunburst.d6bca4c6.svg";
export { ForwardRef as ReactComponent };